export function getFirstName(fullName: string) {
  if (!fullName || typeof fullName !== "string") {
    return "";
  }

  // Split the name by spaces and return the first part
  return fullName.split(" ")[0];
}
